import React from "react";
import googlePlayIcon from "../../assets/images/footer/svg/PlayStore.svg";
import appStoreIcon from "../../assets/images/footer/svg/AppStore.svg";

const ContactSection = () => (
  <div className="flex flex-col">
    <div className="flex flex-col gap-2 font-medium">
      <p className="text-xs font-bold lg:text-base">Contact Us</p>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col text-xs">
          <p>Callers from India</p>
          <p>Toll-free number</p>
          <a href="tel:1800-102-4462" className="text-[#1685CA]">
            1800-102-4462
          </a>
        </div>

        <div className="flex flex-col text-xs">
          <p>Callers outside India</p>
          <a href="tel:+91 22 4985 4100" className="text-[#1685CA]">
            +91 22 4985 4100
          </a>
          <p>(Call charges as per the caller's tariff plan will apply)</p>
        </div>
      </div>
    </div>
    <div className="flex flex-col gap-2 mt-8 font-medium">
      <p className="text-xs font-bold lg:text-base">Email</p>
      <div className="flex flex-col text-xs">
        <p>For any queries email us at</p>
        <a
          href="mailto:customercare@manipalcigna.com"
          className="text-[#1685CA]"
        >
          customercare@manipalcigna.com
        </a>
        <p>
          and for policy alterations, please visit the ManipalCigna E-servicing
          Portal or the MyManipalCigna App
        </p>
      </div>
    </div>
    <div className="flex flex-col gap-2 mt-4 font-medium">
      <p className="text-xs font-bold lg:text-base">
        Download myManipalCigna App
      </p>
      <div className="flex flex-row gap-3 text-xs">
        <a href="https://play.google.com/store/apps/details?id=com.manipalcigna">
          <img src={googlePlayIcon} alt="Google Play" />
        </a>
        <a href="https://apps.apple.com/in/app/mymanipalcignaapp/id6443787650">
          <img src={appStoreIcon} alt="App Store" />
        </a>
      </div>
    </div>
  </div>
);

export default ContactSection;
